export default {
    getWishlistData(state,payload) {
        state.getWishlist = payload;
    },
    search(state,payload){
        state.searchData = payload
    }
}